import React, { useState, useEffect } from "react";
import { Row, Col } from "reactstrap";
import Select from "react-select";
import Chart from "react-apexcharts";
import moment from "moment";

function SuperChart({ dataByDay = [] }) {
  const [allDays, setAllDays] = useState([]);
  const [funcionario, setFuncionario] = useState([]);
  const [revendedor, setRevendedor] = useState([]);
  const [convidado, setConvidado] = useState([]);

  const [darkMode, setDarkMode] = useState(false);

  const [showFuncionario, setShowFuncionario] = useState(true);
  const [showRevendedor, setShowRevendedor] = useState(true);
  const [showConvidado, setShowConvidado] = useState(true);

  function getDays(maxDays) {
    if (!Array.isArray(dataByDay) || dataByDay.length === 0) return;

    const ordered = [...dataByDay].sort(
      (a, b) => new Date(a.date) - new Date(b.date)
    );

    const sliced = ordered.slice(-maxDays);

    setAllDays(sliced.map((d) => moment(d.date).format("DD/MM")));

    setFuncionario(sliced.map((d) => Number(d.funcionario || 0)));
    setRevendedor(sliced.map((d) => Number(d.revendedor || 0)));
    setConvidado(sliced.map((d) => Number(d.convidado || 0)));
  }

  useEffect(() => {
    getDays(7);
  }, [dataByDay]);

  const options = {
    theme: { mode: darkMode ? "dark" : "light" },

    chart: {
      toolbar: { show: false },
    },

    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "55%",
        endingShape: "rounded",
      },
    },

    dataLabels: { enabled: false },

    stroke: {
      show: true,
      width: 2,
      colors: ["transparent"],
    },

    xaxis: {
      categories: allDays,
      labels: {
        style: { fontSize: "12px" },
      },
    },

    yaxis: {
      labels: {
        style: { fontSize: "12px" },
      },
    },

    grid: {
      strokeDashArray: 4,
      borderColor: darkMode ? "#555" : "#e0e0e0",
    },

    legend: {
      position: "top",
      horizontalAlign: "center",
      markers: { size: 10 },
    },

    tooltip: {
      theme: darkMode ? "dark" : "light",
      y: { formatter: (v) => `${v} inscritos` },
    },

    colors: ["#34C759", "#F5A623", "#7B61FF"],
  };

  const series = [
    showFuncionario && { name: "Funcionário", data: funcionario },
    showRevendedor && { name: "Revendedor", data: revendedor },
    showConvidado && { name: "Convidado", data: convidado },
  ].filter(Boolean);

  return (
    <div className={darkMode ? "bg-dark p-3 rounded" : "bg-white p-3 rounded"}>
      <Row className="my-3" style={{ alignItems: "center" }}>
        <Col md={4}>
          <Select
            placeholder="Quantidade de dias"
            onChange={(e) => getDays(e.value)}
            options={[
              { label: "7 dias", value: 7 },
              { label: "15 dias", value: 15 },
              { label: "30 dias", value: 30 },
            ]}
          />
        </Col>

        <Col md={4}></Col>

        <Col md={4} style={{ textAlign: "right" }}>
          <button
            className="btn btn-outline-secondary btn-sm"
            onClick={() => setDarkMode(!darkMode)}
          >
            {darkMode ? "Modo Claro" : "Modo Escuro"}
          </button>
        </Col>
      </Row>

      <Chart options={options} series={series} type="bar" height={420} />
    </div>
  );
}

export default SuperChart;
